import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ConfirmationService, MessageService } from 'primeng/api';

import { Cidade, UF, Area } from '../models/cidade';
import { CidadeService } from '../cidade.service';


@Component({
  selector: 'app-cidade-list',
  templateUrl: './cidade-list.component.html',
  styleUrls: ['./cidade-list.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class CidadeListComponent implements OnInit {

  public listaCidade: Cidade[];
  public listaUF: UF[];
  public listaArea: Area[];
  public idCidade: string;
  public cidade: Cidade;
  public selectedUF: UF;
  public selectedArea: Area;

  public submitted: boolean;
  public displayMsg: boolean = false;
  public displayDialog: boolean;

  constructor(public cidadeService: CidadeService,
    private router: Router,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) { }

  ngOnInit(): void {

   
    this.getCidades();    
    this.getUFs();
    this.getAreas();    
  }

  getUFs() {
    this.cidadeService.getUFs().subscribe(
      (res) => {
        if (res) {
          this.listaUF = res;
        }
      },
      err => {
        console.log("CidadeList - UFs");
        console.log(err);
      }
    );
  }

  getAreas() {
    this.cidadeService.getAreas().subscribe(
      (res) => {
        if (res) {
          this.listaArea = res;
        }
      },
      err => {
        console.log("CidadeList - Areas");
        console.log(err);
      }
    );
  }

  getCidades() {
    this.cidadeService.getCidades().subscribe(
      (res) => {
        if (res) {
          this.listaCidade = res;          
        }
      },
      err => {
        console.log("CidadeList - Cidades");
        console.log(err);
      }
    );
  } 

  getCidade(idCidade) {

    this.cidadeService.getCidade(idCidade).subscribe(
      (res) => {
        if (res) {
          this.cidade = res;
        }
      },
      err => {
        console.log("CidadeList - Cidade");
        console.log(err);
      }
    );
  }
  
  getSelectedUF(uf: string) {
    return this.listaUF.find(x => x.cdUf === uf);
  }

  getSelectedArea(idArea: string) {
    return this.listaArea.find(x => x.idArea === idArea);
  }

  addCidade() {
    this.cidade = {};
    this.selectedArea = {};
    this.selectedUF = {}
    this.submitted = false;
    this.displayDialog = true;
  } 
  
  updCidade(cidade: Cidade) {      
    this.selectedUF = this.getSelectedUF(cidade.uf);
    this.selectedArea = this.getSelectedArea(cidade.idArea);    
    this.cidade = {...cidade};
    this.displayDialog = true;
  }
  
  delCidade(cidade: Cidade) {
      this.confirmationService.confirm({
          message: 'Você tem certeza que deseja remover a cidade: ' + cidade.nome + '?',
          header: 'Confirmação',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
              this.cidadeService
              .delCidade(cidade.idCidade)
              .subscribe(                     
                  () => this.getCidades(),
                  err => console.log(err)
              );
              this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Cidade removida com sucesso!', life: 3000});
          }
      });
  }
  
  hideDialog() {
      this.displayDialog = false;
      this.submitted = false;  
      this.selectedUF = {};    
      this.selectedArea = {};    
  }
  
  //TODO - saveCidade AddCidade
  saveCidade() {
      this.submitted = true;      
      if (this.cidade.nome.trim()) {
          if (this.cidade.idCidade) {
            
            this.cidadeService
            .updCidade(this.cidade)
            .subscribe(                     
                () => this.getCidades(),
                err => console.log(err)
            );
              this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Cidade atualizada com sucesso!', life: 3000});
          } else {
             this.cidadeService
                 .addCidade(this.cidade)
                 .subscribe(                     
                     () => this.getCidades(),
                     err => 
                     {
                        this.messageService.add({severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações!', life: 3000});
                       console.log(err)
                     }
                 );

              this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Cidade cadastrada com sucesso!', life: 3000});
          }
  
          this.listaCidade = [...this.listaCidade];
          this.displayDialog = false;
          this.cidade = {};
      }
  }

  SetUF(UF)
  {
    this.cidade.uf = UF.cduf;
  }

  SetArea(idArea)
  {
    this.cidade.idArea = idArea.idArea;
  }
}
